import { type PlotRequestTag, type MapPlotRequest } from "@/features/map/types";

/**
 * MapPlotRequestの配列からユニークなタグを抽出する
 * タグ名を基準に重複を排除する（フィルター候補用）
 * @param requests MapPlotRequestの配列
 * @returns 重複を除いたタグの配列
 */
export const extractUniqueTags = (
  requests: MapPlotRequest[]
): PlotRequestTag[] => {
  const tagsMap = new Map<string, PlotRequestTag>();
  requests.forEach((request) => {
    request.tags?.forEach((tag) => {
      if (!tagsMap.has(tag.name)) {
        tagsMap.set(tag.name, tag);
      }
    });
  });
  return Array.from(tagsMap.values());
};
